/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/blocks/job-listings.module.scss';
import JobListing from '../cards/JobListing';

const propTypes = {
    jobListings: PropTypes.arrayOf(PropTypes.shape({})),
    isContainer: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    jobListings: null,
    isContainer: false,
    className: null,
};

const JobListingsBlock = ({ jobListings, isContainer, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.isContainer]: isContainer,
            },
        ])}
    >
        {(jobListings || []).map((job) => (
            <div className={styles.jobListing}>
                <JobListing item={job} />
            </div>
        ))}
    </div>
);

JobListingsBlock.propTypes = propTypes;
JobListingsBlock.defaultProps = defaultProps;

export default JobListingsBlock;
